import {Controller} from "stimulus"

export default class extends Controller {
    static targets = ["links", "template", "container"]

    connect() {
        console.log("log from nested_form controller");
    }

    addAssociation(e) {
        e.preventDefault();
        let content = this.templateTarget.innerHTML;
        content = content.replace(/NEW_RECORD/g, new Date().getTime());
        let newElement;
        if (this.hasContainerTarget) {
            this.containerTarget.insertAdjacentHTML('afterbegin', content);
            newElement = this.containerTarget.firstElementChild;
        } else {
            this.linksTarget.insertAdjacentHTML('beforebegin', content);
            newElement = this.linksTarget.previousElementSibling;
        }
        this.highlightNewRecord(newElement);
        this.focusFirstInput(newElement);
    }

    removeAssociation(e) {
        e.preventDefault();
        let wrapper = e.target.closest(".nested-fields");
        if (wrapper.dataset.newRecord == "true") {
            wrapper.remove();
        } else {
            wrapper.querySelector("input[name*='_destroy']").value = 1;
            wrapper.style.display = 'none';
        }
    }

    focusFirstInput(element) {
        if (!element) return;
        const input = element.querySelector("input[type='text'], textarea, input:not([type='hidden']):not([type='checkbox'])");
        if (input) input.focus();
    }

    highlightNewRecord(element) {
        if (!element) {
            return;
        }

        const highlightColor = "#f3e8ff";
        element.style.transition = "background-color 1000ms";
        element.style.backgroundColor = highlightColor;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                element.style.backgroundColor = "";
            });
        });
        setTimeout(() => {
            element.style.transition = "";
        }, 1100);
    }

}
